/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type WeeklySummaryFeedback = "No" | "NoOpinion" | "Yes" | "%future added value";
export type WeeklySummaryResponseMutationInput = {
    clientMutationId?: string | null | undefined;
    feedback?: WeeklySummaryFeedback | null | undefined;
    maxDate: string;
    minDate: string;
    orgRelayId: string;
};
export type WeeklySummaryResponseMutationVariables = {
    input: WeeklySummaryResponseMutationInput;
};
export type WeeklySummaryResponseMutationResponse = {
    readonly weeklySummaryResponse: {
        readonly response: boolean | null;
    } | null;
};
export type WeeklySummaryResponseMutation = {
    readonly response: WeeklySummaryResponseMutationResponse;
    readonly variables: WeeklySummaryResponseMutationVariables;
};



/*
mutation WeeklySummaryResponseMutation(
  $input: WeeklySummaryResponseMutationInput!
) {
  weeklySummaryResponse(input: $input) {
    response
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "WeeklySummaryResponseMutationPayload",
            "kind": "LinkedField",
            "name": "weeklySummaryResponse",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "response",
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "WeeklySummaryResponseMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "WeeklySummaryResponseMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "3945ba524ad7982aab9e0c09fb27413e",
            "id": null,
            "metadata": {},
            "name": "WeeklySummaryResponseMutation",
            "operationKind": "mutation",
            "text": "mutation WeeklySummaryResponseMutation(\n  $input: WeeklySummaryResponseMutationInput!\n) {\n  weeklySummaryResponse(input: $input) {\n    response\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '91b9a6eb347807ca5170a9b4e4652253';
export default node;
